
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.887 6.111a3.132 3.132 0 01-.48 1.577A2.904 2.904 0 016.17 8.742c-.527.25-1.13.375-1.81.375-1.122 0-2.005-.365-2.65-1.096-.644-.73-.966-1.761-.966-3.093v-.422c0-.836.145-1.567.434-2.192.293-.628.713-1.113 1.26-1.453.546-.343 1.18-.515 1.898-.515 1.035 0 1.867.273 2.496.82.629.543.986 1.293 1.072 2.25h-2.05c-.016-.52-.147-.893-.393-1.12-.246-.226-.621-.339-1.125-.339-.512 0-.887.191-1.125.574-.238.383-.363.994-.375 1.834v.604c0 .91.113 1.56.34 1.95.23.392.625.587 1.183.587.473 0 .834-.111 1.084-.334.25-.223.383-.576.399-1.06h2.045zm5.373.621c0-.3-.108-.535-.322-.703-.211-.168-.585-.341-1.12-.521a10.76 10.76 0 01-1.312-.522C9.4 4.443 8.848 3.697 8.848 2.748c0-.473.136-.889.41-1.248.277-.363.668-.645 1.172-.844.504-.203 1.07-.304 1.699-.304.613 0 1.162.109 1.646.328.489.218.868.53 1.137.937.27.403.404.863.404 1.383h-2.05c0-.348-.108-.617-.323-.809-.21-.191-.498-.287-.861-.287-.367 0-.658.082-.873.246a.74.74 0 00-.316.616c0 .218.117.418.351.597.235.176.647.36 1.236.551.59.188 1.075.39 1.454.61.921.53 1.382 1.263 1.382 2.197 0 .746-.28 1.332-.843 1.758-.563.425-1.334.638-2.315.638-.691 0-1.318-.123-1.88-.369-.56-.25-.981-.59-1.266-1.02a2.684 2.684 0 01-.422-1.494h2.062c0 .457.118.795.352 1.014.238.215.623.322 1.154.322.34 0 .608-.072.803-.216a.73.73 0 00.299-.622zm6.422-.052L21.38.469h2.297L20.807 9h-2.25L15.709.469h2.28l1.693 6.21z","fill":"#fff"}})])
          )
        }
      }
    